import { AxiosPromise } from 'axios';
import { IVisitorAgreementFormValues } from '../form';
import { instance } from '../../../../services';

const updateVisitorAgreement = (
  data: IVisitorAgreementFormValues,
): AxiosPromise => {
  const { id } = data;

  return instance.put(`/api/visitorAgreements/${id}`, data);
};

export default updateVisitorAgreement;
